export default __webpack_public_path__ + "static/media/elo-books-symbol.0670c0a5.svg";